module.exports = __webpack_public_path__ + "img/c9623ee49ada4928b98080ab2b8a72c6.svg";